import axios from "axios";

import { encryptStorage } from "../../constants/EncryptStorage";
import { BASEURL } from "../../constants/const";

export function ApiAhbab() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  const fileAuthAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
    responseType: "arraybuffer",
  });

  const url = BASEURL + "ahbab/";
  return {
    Add: (data) => authAxios.put(url + "Add/", data),
    Edit: (id) => authAxios.get(url + "Edit/" + id),
    Update: (id, record) => authAxios.put(url + "Edit/" + id, record),
    Delete: (id) => authAxios.delete(url + "Delete/" + id),
    GetSimilarAhbabByMobileNumber: (phoneNo = "none") =>
      authAxios.get(url + "GetSimilarAhbabByMobileNumber/" + phoneNo),
    GetSimilarAhbabByMobileNumberForEventAttendance: (
      phoneNo = "none",
      eventId
    ) =>
      authAxios.get(
        url +
          "GetSimilarAhbabByMobileNumberForEventAttendance/" +
          phoneNo +
          "/" +
          eventId
      ),
    GetCountries: () => authAxios.get(url + "GetCountries/"),
    GetStates: (countryId) => authAxios.get(url + "GetStates/" + countryId),
    GetCities: (stateId) => authAxios.get(url + "GetCities/" + stateId),
    GetContactFormAhbab: (searchAhbabModel) =>
      authAxios.post(url + "GetContactFormAhbab/", searchAhbabModel),
    GetAhbabExcelReport: (searchAhbabModel) =>
      fileAuthAxios.post(url + "GetAhbabExcelReport/", searchAhbabModel),
    GetSystemAhbabExcelReport: (searchAhbabModel) =>
      fileAuthAxios.post(url + "GetSystemAhbabExcelReport/", searchAhbabModel),
    TransferHabib: (record) => authAxios.post(url + "TransferHabib/", record),
    TransferLocalAhbab: (record) =>
      authAxios.post(url + "TransferLocalAhbab/", record),
    MoveHabibDataSave: (record) =>
      authAxios.put(url + "MoveHabibDataSave/", record),
    GetAhbab: (searchAhbabModel) =>
      authAxios.post(url + "getAhbab/", searchAhbabModel),
    CancelHabib: (id) => authAxios.put(url + "CancelHabib/" + id),
    TanzeemOrgAhbabStatusReport: (values) =>
      authAxios.post(url + "TanzeemOrgAhbabStatusReport/", values),
    GenerateTanzeemOrgAhbabStatusReportExcel: (values) =>
      fileAuthAxios.post(
        url + "GenerateTanzeemOrgAhbabStatusReportExcel/",
        values
      ),
  };
}
